module.exports = __webpack_public_path__ + "static/img/14003002.4250164d.png";